// Builds /api/assets/data URLs, tagging them with the device/player id for admin bandwidth
// attribution. The id is injected by the server on device/player pages via a window global
// (window.WEBCY_ASSET_CLIENT = { deviceId } | { playerId }), so no playback component is involved.
// On the dashboard/editor the global is unset and the bare URL is returned.

export function assetUrl(assetId) {
    if (!assetId) return '';
    // Already an absolute/external URL — leave untouched.
    if (typeof assetId === 'string' && assetId.indexOf('http') === 0) return assetId;

    var base = '/api/assets/data/' + assetId;
    var client = (typeof window !== 'undefined' && window.WEBCY_ASSET_CLIENT) || null;
    if (client) {
        if (client.deviceId) return base + '?deviceId=' + client.deviceId;
        if (client.playerId) return base + '?playerId=' + client.playerId;
    }
    return base;
}
